(function ($) {
    function FormValidator(form) {
        this.$form = $(form);
        this.defaults = {
            // Form elements and children which match this selector are not validated
            skipJsValidationSelector: ".u-no-validate",
            // This CSS class is added to the generated error messages
            errorMessageClass: "u-error",
            // This class is added to the parent item of input elements if they are invalid
            invalidClass: "u-is-invalid",
            // Input or all child inputs of this class validate on change or keyup
            validateOnChangeClass: "u-validate-on-change",
            // Error message is shown if no error message attribute can bef found: data-error-msg-TYPE=""
            fallbackErrorMessage: "Error: This field is mandatory."
        };
        this.settings = $.extend({}, this.defaults, this.$form.data("settings") || {});
        this.init();
    }

    $.extend(FormValidator.prototype, {

        init: function () {
            var that = this;
            // disable default HTML5 validation
            this.$form.attr("novalidate", "novalidate");
            this.$form.on('submit', function (e) {
                if (!that.validateForm(e).isValid) {
                    e.preventDefault();
                    return false;
                }
            });

            // remove error message on change
            this.$form.on("change keyup", "input, textarea, select", function (e) {
                var $item = $(e.currentTarget),
                    validator = $item.closest(".u-form").data("validate");

                if ($item.closest("." + that.settings.validateOnChangeClass).length === 0 || !validator) return;

                validator.removeSingleErrorMessage($item);
            });
        },

        validateForm: function (event) {
            var that = this,
                isFormValid = true,
                invalidItems = [],
                result;

            that.removeAllErrorMessages();
            that.getAllValidationItems().each(function () {
                var $item = $(this),
                    validationResult;

                if (!$item.closest(that.settings.skipJsValidationSelector).length) {
                    validationResult = that.validateItem($item);

                    if (!validationResult["isValid"]) {
                        invalidItems.push(this);
                        isFormValid = false;
                    }
                }
            });

            var $recaptchaTextarea = that.$form.find(".g-recaptcha-response");

            if ($recaptchaTextarea && ($recaptchaTextarea.val().length == 0)) {
                that.showErrorMessage($recaptchaTextarea, "required");
                invalidItems.push($recaptchaTextarea);
                isFormValid = false;
            }

            result = {
                originalEvent: event,
                isValid: isFormValid,
                invalidItems: invalidItems
            };

            that.$form.trigger("validation-complete", result);

            // after first validation add class
            that.$form.addClass(that.settings.validateOnChangeClass);

            return result;
        },

        getAllValidationItems: function () {
            return this.$form
                .find("input, select, textarea, [contenteditable]")
                .not(":submit, :reset, :image, :disabled, :hidden");
        },

        getErrorMessage: function ($item, validationType) {
            var errorMsg = this.settings.fallbackErrorMessage;

            if ($item.closest("[data-error-msg-" + validationType + "]").length) {
                errorMsg = $item.closest("[data-error-msg-" + validationType + "]").data("error-msg-" + validationType);
            } else if ($item.closest("[data-error-msg-default]").length) {
                errorMsg = $item.closest("[data-error-msg-default]").data("error-msg-default");
            }

            return errorMsg;
        },

        showErrorMessage: function ($item, validationType) {
            var $error = $("<span>")
                    .text(this.getErrorMessage($item, validationType))
                    .addClass(this.settings.errorMessageClass),
                $parentItem;

            $item.addClass(this.settings.invalidClass);

            if ($item.closest(".u-combined-input").length) {
                $parentItem = $item.closest(".u-combined-input");
                $parentItem.addClass(this.settings.invalidClass);

                $parentItem.after($error);
                return;
            } else if ($item.closest(".u-select").length) {
                $parentItem = $item.closest(".u-select");
                var $select = $parentItem.prev("select.u-select");
                $parentItem.addClass(this.settings.invalidClass);
                $select.addClass(this.settings.invalidClass);
            } else if ($item.closest(".u-checkbox").length) {
                $parentItem = $item.closest(".u-checkbox");
                $parentItem.addClass(this.settings.invalidClass);
            } else if ($item.hasClass("g-recaptcha-response")) {
                $parentItem = $item.closest(".g-recaptcha");
                $parentItem.addClass(this.settings.invalidClass);
            } else {
                $parentItem = $item.parent();
            }

            $parentItem.append($error);
        },

        removeSingleErrorMessage: function ($item) {
            var $parentItem;

            if ($item.closest(".u-combined-input").length) {
                $parentItem = $item.closest(".u-combined-input");
                $parentItem.removeClass(this.settings.invalidClass);

                $parentItem.next("." + this.settings.errorMessageClass).remove();
            }
            if ($item.closest(".u-select").length) {
                var $select = $item.closest(".u-select");
                $parentItem = $select.next("div.u-select");
                $select.removeClass(this.settings.invalidClass);
                $parentItem.removeClass(this.settings.invalidClass);
            } else if ($item.closest(".u-checkbox").length) {
                $parentItem = $item.closest(".u-checkbox");
                $parentItem.removeClass(this.settings.invalidClass);
            } else if ($item.closest(".u-radio").length) {
                $parentItem = $("input[name='" + $item.attr("name") + "']").closest(".u-radio");
                $parentItem.removeClass(this.settings.invalidClass);
            } else {
                $parentItem = $item.parent();
            }

            $parentItem.find("." + this.settings.errorMessageClass).remove();
            $item.removeClass(this.settings.invalidClass);

            this.validateItem($item);
        },

        removeAllErrorMessages: function () {
            this.$form.find("." + this.settings.errorMessageClass).remove();
            this.$form.find("." + this.settings.invalidClass).removeClass(this.settings.invalidClass);
        },

        validateItem: function ($item) {
            var that = this,
                isValid = true,
                value = $item.val();

            $.each(validationSetup, function (validatorName, selector) {
                var validationFunction = validationFunctions[validatorName];
                if ($item.is(selector) && !validationFunction(value, $item[0], $item.attr(validatorName))) {
                    that.showErrorMessage($item, validatorName);
                    isValid = false;

                    return false;
                }
            });

            return {
                isValid: isValid
            };
        }
    });

    $.fn.validate = function () {
        return this.each(function () {
            if (!$.data(this, 'validate')) {
                $.data(this, 'validate', new FormValidator(this));
            }
        });
    };

    // Auto initialize on DOM ready
    $(function () {
        $("form.u-validate").each(function () {
            $(this).validate();
        });
    });

    // {Validator key: HTML selector}
    var validationSetup = {
        "email": "input[type=email]",
        "url": "input[type=url]",
        "date": "input[type=date]",
        "number": "[number]",
        "digits": "[digits]",
        "min": "[min]",
        "max": "[max]",
        "range": "[range]",
        "required": "[required]",
        "erpIdPattern": "[data-erp-id-pattern]",
        "iban": "[data-iban]"
    };

    // http://jqueryvalidation.org/jQuery.validator.methods/
    var validationFunctions = {
        checkable: function (element) {
            return (/radio|checkbox/i).test(element.type);
        },

        getLength: function (value, element) {
            switch (element.nodeName.toLowerCase()) {
                case "select":
                    return $("option:selected", element).length;
                case "input":
                    if (this.checkable(element)) {
                        return $(element).filter(":checked").length;
                    }
            }
            return value.length;
        },

        // http://jqueryvalidation.org/required-method/
        required: function (value, element) {
            if (element.nodeName.toLowerCase() === "select") {

                // Could be an array for select-multiple or a string, both are fine this way
                var val = $(element).val();
                return val && val.length > 0;
            }
            if ((/radio|checkbox/i).test(element.type)) {
                return validationFunctions.getLength(value, element) > 0;
            }
            return $.trim(value).length > 0;
        },

        // http://jqueryvalidation.org/email-method/
        email: function (value) {

            // From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
            // Retrieved 2014-01-14
            // If you have a problem with this implementation, report a bug against the above spec
            // Or use custom methods to implement your own email validation
            return !value.length || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
        },

        // http://jqueryvalidation.org/url-method/
        url: function (value) {

            // Copyright (c) 2010-2013 Diego Perini, MIT licensed
            // https://gist.github.com/dperini/729294
            // see also https://mathiasbynens.be/demo/url-regex
            // modified to allow protocol-relative URLs
            return !value.length || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },

        // http://jqueryvalidation.org/date-method/
        date: function (value) {
            return !value.length || !/Invalid|NaN/.test(new Date(value).toString());
        },

        // http://jqueryvalidation.org/number-method/
        number: function (value) {
            return !value.length || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value);
        },

        // http://jqueryvalidation.org/digits-method/
        digits: function (value) {
            return !value.length || /^\d+$/.test(value);
        },

        // http://jqueryvalidation.org/min-method/
        min: function (value, element, param) {
            return value >= param;
        },

        // http://jqueryvalidation.org/max-method/
        max: function (value, element, param) {
            return value <= param;
        },

        // http://jqueryvalidation.org/range-method/
        range: function (value, element, param) {
            return (value >= param[0] && value <= param[1]);
        },

        erpIdPattern: function (value, element, param) {
            var $element = $(element),
                combinedSelectize = $element.closest('.u-combined-input').find('select.u-select').data('selectize'),
                pattern = $element.data('erp-id-pattern');

            if ((pattern === 1 || pattern === true) && combinedSelectize) {
                var val = combinedSelectize.$input.val();
                pattern = ((combinedSelectize.options[val] || {}).data || {}).erpIdPattern;
            }

            pattern = typeof (pattern) === "string" ? pattern : "";

            return !value.length || new RegExp(pattern).test(value);
        },

        // https://www.regextester.com/115565
        iban: function (value) {
            return !value.length || /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/.test(value.replaceAll(" ", ""));
        }
    };

})(jQuery);